
<div class="container" id="container" #container>
  <div class="form-container sign-up-container">
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <h1>Create Account</h1>
      <span>or use your email for registration</span>
    
      <input class="form-control" type="text" formControlName="name" placeholder="Name">
      <div *ngIf="registerForm.get('name')?.touched && registerForm.get('name')?.invalid" class="text-danger">
        <small style="text-align: left;" *ngIf="registerForm.get('name')?.errors?.required">Name is required.</small>
      </div>
    
      <input class="form-control" type="text" formControlName="user_name" placeholder="Username">
      <div *ngIf="registerForm.get('user_name')?.touched && registerForm.get('user_name')?.invalid" class="text-danger">
        <small *ngIf="registerForm.get('user_name')?.errors?.required">Username is required.</small>
        <small *ngIf="registerForm.get('user_name')?.errors?.minlength">Username must be at least 3 characters long.</small>
      </div>
    
      <input class="form-control" type="text" formControlName="company_name" placeholder="Company Name">
      <div *ngIf="registerForm.get('company_name')?.touched && registerForm.get('company_name')?.invalid" class="text-danger">
        <small *ngIf="registerForm.get('company_name')?.errors?.required">Company Name is required.</small>
      </div>
    
      <input class="form-control" type="text" formControlName="country" placeholder="Country">
      <div *ngIf="registerForm.get('country')?.touched && registerForm.get('country')?.invalid" class="text-danger">
        <small *ngIf="registerForm.get('country')?.errors?.required">Country is required.</small>
      </div>
    
      <!-- <input class="form-control" type="number" formControlName="contact_no" placeholder="Contact Number"> -->
      <ngx-intl-tel-input
      [cssClass]="'form-control'"
      [preferredCountries]="['us', 'gb']"
      [enableAutoCountrySelect]="true"
      [enablePlaceholder]="true"
      [searchCountryFlag]="true"
      [searchCountryField]="['name', 'dialCode']"
      [selectFirstCountry]="false"
      [selectedCountryISO]="'us'" 
      [phoneValidation]="true"
      [separateDialCode]="true"
      formControlName="contact_no">
    </ngx-intl-tel-input>

    
    

  <!-- <ngx-intl-tel-input [cssClass]="'form-control'" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
  [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
  [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
  [phoneValidation]="true" [separateDialCode]="true" name="phone" formControlName="phone">
</ngx-intl-tel-input> -->
  
  <div *ngIf="registerForm.get('contact_no')?.touched && registerForm.get('contact_no')?.invalid" class="text-danger">
    <small *ngIf="registerForm.get('contact_no')?.errors?.required">Contact Number is required.</small>
    <small *ngIf="registerForm.get('contact_no')?.errors?.pattern">Contact Number must be numeric.</small>
  </div>
  
    
      <input class="form-control" type="text" formControlName="referenced_by" placeholder="Referred by">
      
      <select class="form-control" formControlName="currency" id="currency">
        <option value="" disabled selected>Select Currency</option>
        <option value="USD" >US Dollar</option>
        <option value="GBP">British Pound</option>
        <option value="CAD">Canadian Dollar</option>
        <option value="AUD">Australian Dollar</option>
        <option value="EUR">Euro</option>
        <!-- Add more currency options as needed -->
      </select>
      <div *ngIf="registerForm.get('currency')?.touched && registerForm.get('currency')?.invalid" class="text-danger">
        <small *ngIf="registerForm.get('currency')?.errors?.required">Currency is required.</small>
      </div>
    
      <input class="form-control" type="email" formControlName="email" placeholder="app@yourmail.com">
      <div *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.invalid" class="text-danger">
        <small *ngIf="registerForm.get('email')?.errors?.required">Email is required.</small>
        <small *ngIf="registerForm.get('email')?.errors?.email">Invalid email format.</small>
      </div>
    



      <div style="position: relative;">
        <input 
          class="form-control" 
          [type]="showPassword ? 'text' : 'password'" 
          formControlName="password" 
          required="" 
          placeholder="*********"
          style="padding-right: 2.5rem; width: 22.5rem;">
        <div *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.invalid" class="text-danger">
          <small *ngIf="registerForm.get('password')?.errors?.required">Password is required.</small>
          <small *ngIf="registerForm.get('password')?.errors?.minlength">Password must be at least 6 characters long.</small>
        </div>
        <!-- Eye Icon -->
        <i 
          [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'" 
          (click)="togglePasswordVisibility()" 
          style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer; color: #6c757d;">
        </i>
      </div>
    

    
      <button
      class="btn btn-block"
      [disabled]="!registerForm.valid"
      type="submit"
    >
      <span>Create Account</span>
    </button>
    </form>
    
  </div> 
  <div class="form-container sign-in-container">
    <form [formGroup]="loginForm">
      <h1>Sign in</h1>
  
      <!-- Email Input -->
      <input 
        class="form-control" 
        type="email" 
        required="" 
        placeholder="app@yourmail.com"  
        style="    margin-top: 25px;"
        formControlName="email">
      <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" class="text-danger">
        <small *ngIf="loginForm.get('email')?.errors?.required">Email is required.</small>
        <small *ngIf="loginForm.get('email')?.errors?.email">Invalid email format.</small>
      </div>
  
      <!-- Password Input with Eye Icon -->
      <div style="position: relative;">
        <input 
          class="form-control" 
          [type]="showPassword ? 'text' : 'password'" 
          formControlName="password" 
          required="" 
          placeholder="*********"
          style="padding-right: 2.5rem; width: 22.5rem;">
        <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" class="text-danger">
          <small *ngIf="loginForm.get('password')?.errors?.required">Password is required.</small>
          <small *ngIf="loginForm.get('password')?.errors?.minlength">Password must be at least 6 characters long.</small>
        </div>
        <!-- Eye Icon -->
        <i 
          [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'" 
          (click)="togglePasswordVisibility()" 
          style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer; color: #6c757d;">
        </i>
      </div>

      <a routerLink="/auth/forget-password">Forget Password?</a>

  
      <!-- Login Button -->
      <button
        class="btn btn-block"
        [disabled]="!loginForm.valid"
        (click)="login()"
        style="margin-top: 17px;"
        type="button"
      >
        <span>Login</span>
      </button>
    </form>
  </div>
  
<div class="overlay-container">
  <div class="overlay">
      <div class="overlay-panel overlay-left">
          <img src="https://client.punchdigitizing.com/digitizing_api/public/login.png" alt="Logo" style="width: 175px; width: 100%;
          /* height: 100%; */
          margin-top: -200px;">
          <h1 style="margin-top: -27px;">Welcome Back!</h1>
          <p>To keep connected with us please login with your personal info</p>
          <button class="ghost  btn-block" style="    width: 24rem;" id="signIn">Sign In</button>
      </div>
      <div class="overlay-panel overlay-right">
          <img src="https://client.punchdigitizing.com/digitizing_api/public/login.png"  alt="Logo" style="width: 100%;
          /* height: 100%; */
          margin-top: -200px; ">
          <h1 style="margin-top: -27px;">Welcome to Punch Digitizing!</h1>
          <p>Enter your personal details and start journey with us</p>
          <button class="ghost"  style="    width: 24rem;" id="signUp">Sign Up</button>
      </div>
  </div>
</div>

<script>

</script>